/** @format */

import React from "react";

const Story = () => {
  return (
    <div className="story content" id="story">
      <h1>Our Story</h1>
      <section className="text">
        Although Soul4English started 9 years ago, Abusaeed Duha Saeed, the
        founder of Soul4English, collected many experiences through his previous
        years of community service. In 2010, Saeed began teaching a handful of
        non-native English speakers in hopes of enabling them a better future.
        Noticing the rapid growth in their English speaking skills, other
        students joined Saeed's class, and the number of students quickly grew.
        Since demand swiftly increased over the next few years, and with the
        instructors that taught his previous classes, Saeed proceeded to start
        Soul4English for non-native English speakers globally. Soul4English has
        taught over 200 students globally and continues to revolutionize its
        curriculum for newer students.
      </section>
    </div>
  );
};

export default Story;
